import { Dropdown, Modal } from 'react-bootstrap';
import Input from '../../../components/bootstrap/forms/Input';
import Icon from '../../../components/icon/Icon';
import PageWrapper from '../../../layout/PageWrapper/PageWrapper';
import SubHeader, {
	SubHeaderLeft,
	SubHeaderRight,
	SubheaderSeparator,
} from '../../../layout/SubHeader/SubHeader';
import { DropdownMenu, DropdownToggle } from '../../../components/bootstrap/Dropdown';
import Button from '../../../components/bootstrap/Button';
import Popovers from '../../../components/bootstrap/Popovers';
import FormGroup from '../../../components/bootstrap/forms/FormGroup';
import Checks, { ChecksGroup } from '../../../components/bootstrap/forms/Checks';
import Card, {
	CardActions,
	CardBody,
	CardHeader,
	CardLabel,
	CardTitle,
} from '../../../components/bootstrap/Card';
import { useEffect, useState, useCallback } from 'react';
import { getFirstLetter } from '../../../helpers/helpers';
import Avatar from '../../../components/Avatar';
import { getImageUrl } from '../../../api';
import { api_deleteCategory, api_getCategories, api_getCategoryById } from '../../../api/category';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import { AsyncPaginate } from 'react-select-async-paginate';

const PAGE_SIZE = 5;
export const SelectAsyncPaginate = ({ value, onChange }: { onChange: any; value: any }) => {
	const loadOptions = useCallback(
		async (
			searchQuery: any,
			loadedOptions: any,
			additional: { page: number } = { page: 1 },
		) => {
			const { page } = additional;
			const res = await api_getCategories(page, 10);
			return {
				options: res.data,
				// hasMore: res.data.length >= 1,
				// additional: {
				//     page: page + 1,
				// },
			};
		},
		[],
	);

	return (
		<AsyncPaginate
			value={value}
			loadOptions={loadOptions}
			getOptionValue={(option) => option._id}
			getOptionLabel={(option) => option.name}
			onChange={onChange}
			isSearchable={false}
			placeholder='Select Category'
			additional={{
				page: 1,
			}}
		/>
	);
};
const AllCategory = () => {
	const [category, setCategory] = useState<any>([]);
	const [filterModalOpen, setFilterModalOpen] = useState(false);
	const [loading, setLoading] = useState(false);
	const [deletLoadingIndex, setDeletLoadingIndex] = useState<null | number>(null);
	const [pageNo, setPageNo] = useState(1);
	const [hasMore, setHasMore] = useState(true);
	const [selectedCategory, setSelectedCategory] = useState<any>(null);
	const [filter, setFilter] = useState(false);
	const navigate = useNavigate();
	const getCategory = async () => {
		if (loading) return;
		try {
			setLoading(true);
			const res = await api_getCategories(pageNo, PAGE_SIZE);
			if (res.isSuccess) {
				if (!res.data.length) {
					setHasMore(false);
					return;
				}
				if (!filter) {
					setCategory(() => [...res.data]);
				}
			}
		} catch (error) {
			console.log(error);
		} finally {
			setLoading(false);
		}
	};
	const getCategoryWithFilter = async () => {
		setCategory([]);
		setFilter(true);
		if (loading) return;
		try {
			setLoading(true);
			const res = await api_getCategoryById(selectedCategory._id);
			setCategory([res.data]);
			if (res.isSuccess) {
				if (!res.data.length) {
					setHasMore(false);
					return;
				}
				setCategory(res.data);
				setPageNo(pageNo + 1);
			}
		} catch (error) {
			console.log(error);
		} finally {
			setLoading(false);
		}
	};

	const onLoadMore = () => {
		if (hasMore) {
			setPageNo(pageNo + 1);
			getCategory();
		}
	};

	const deleteCategory = async (id: string, index: number) => {
		setDeletLoadingIndex(index);
		try {
			const res = await api_deleteCategory(id);
			if (res.isSuccess) {
				toast.success(res.message || 'success');
				setCategory(
					category.filter((item: any) => {
						return item._id !== id;
					}),
				);
			}
		} catch (error) {
			console.log(error);
		} finally {
			setDeletLoadingIndex(null);
		}
	};
	const handleFilterReset = () => {
		setCategory([]);
		setHasMore(true);
	};

	useEffect(() => {
		getCategory();
	}, []);

	return (
		<>
			<Modal
				show={filterModalOpen}
				onHide={() => setFilterModalOpen(false)}
				keyboard={false}
				size='sm'
				aria-labelledby='contained-modal-title-vcenter'
				centered>
				<Modal.Header closeButton>
					<Modal.Title>Category Filter</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className='mb-3'>
						<label htmlFor='formFileSm' className='form-label'>
							Category
						</label>
						<SelectAsyncPaginate
							onChange={setSelectedCategory}
							value={selectedCategory}
						/>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<Button onClick={getCategoryWithFilter}>Search</Button>
					<Button onClick={() => setFilterModalOpen(false)}>Close</Button>
					<Button onClick={handleFilterReset}>Reset</Button>
				</Modal.Footer>
			</Modal>
			<PageWrapper title={'Category'}>
				<div style={{ marginTop: '20px' }}>
					<SubHeader>
						<SubHeaderLeft>
							<label
								className='border-0 bg-transparent cursor-pointer me-0'
								htmlFor='searchInput'>
								<Icon
									onClick={() => {
										setCategory([]);
										setHasMore(true);
										getCategoryWithFilter();
									}}
									icon='Search'
									size='2x'
									color='primary'
								/>
							</label>
						</SubHeaderLeft>
						<SubHeaderRight>
							<Dropdown>
								<DropdownToggle hasIcon={false}>
									<Button
										onClick={() => setFilterModalOpen(true)}
										icon='FilterAlt'
										color='dark'
										isLight
										className='btn-only-icon position-relative'>
										<Popovers desc='Filtering applied' trigger='hover'>
											<span className='position-absolute top-0 start-100 translate-middle badge border border-light rounded-circle bg-danger p-2'>
												<span className='visually-hidden'>
													there is filtering
												</span>
											</span>
										</Popovers>
									</Button>
								</DropdownToggle>
								<DropdownMenu isAlignmentEnd size='lg'>
									<div className='container py-2'>
										<div className='row g-3'>
											<FormGroup label='Order Filter' className='col-12'>
												<ChecksGroup>
													<Checks
														key='1'
														id=''
														label='Active'
														name='Active'
														value={'true'}
														//  onChange={(e)=>handleFilterApi(e)}
														//  checked={selectedFilters.includes('true')}
													/>

													<Checks
														key='2'
														id=''
														label='Price(low to high)'
														name='Payment'
														value={'false'}
														//  onClick={(e)=>handleFilterApi(e)}
														//  checked={selectedFilters.includes('false')}
													/>
													<Checks
														key='2'
														id=''
														label='Price(high to low)'
														name='Payment'
														value={'false'}
														//  onClick={(e)=>handleFilterApi(e)}
														//  checked={selectedFilters.includes('false')}
													/>
													<Checks
														key='3'
														id=''
														label='Ratings'
														name='Ratings'
														value={'Ratings'}
														//  onClick={(e)=>handleFilterApi(e)}
														//  checked={selectedFilters.includes('ascending')}
													/>
													{/* <Checks
												 key='4'
												 id=""
												 label="Dscending"
												 name="Dscending"
												 value = {'dscending'}
												//  onClick={(e)=>handleFilterApi(e)}
												//  checked={selectedFilters.includes('dscending')}


											 /> */}
												</ChecksGroup>
											</FormGroup>
										</div>
									</div>
								</DropdownMenu>
							</Dropdown>
							<SubheaderSeparator />
						</SubHeaderRight>
					</SubHeader>
				</div>
				<Card stretch>
					<CardHeader borderSize={1}>
						<CardLabel icon='Alarm' iconColor='info'>
							<CardTitle>All Category</CardTitle>
						</CardLabel>
						<CardActions>
							<Button
								icon='PersonAdd'
								onClick={() => navigate('/add/category')}
								color='primary'
								isLight={true}>
								New Category
							</Button>
						</CardActions>
					</CardHeader>
					<CardBody isScrollable className='table-responsive'>
						<table className='table table-modern'>
							<thead>
								<tr>
									<td style={{ width: 60 }} />
									<th>Name </th>
									<th>Image</th>
									<th>Description</th>
									<th>Action</th>
								</tr>
							</thead>
							<tbody>
								{category?.map((item: any, index: any) => {
									return (
										<tr key={index}>
											<td>
												<div className='flex-shrink-0'>
													<div
														className='ratio ratio-1x1 me-3'
														style={{ width: 48 }}>
														<div
															className='ratio ratio-1x1 me-3 '
															style={{ width: 50 }}>
															{item?.avatar ? (
																<Avatar
																	src={getImageUrl(item?.avatar)}
																/>
															) : (
																<div>
																	<span className='fw-bold'>
																		{item?.name
																			? getFirstLetter(
																					item.name,
																			  )
																			: ''}
																	</span>
																</div>
															)}
														</div>
													</div>
												</div>
											</td>

											<td>
												<div className='d-flex'>
													<div className='flex-grow-1'>
														<div className='fs-6 fw-bold'>
															{item?.name}
														</div>
													</div>
												</div>
											</td>
											<td>
												<img
													src={getImageUrl(item?.image)}
													style={{
														width: 50,
														height: 50,
														borderRadius: 50,
														objectFit: 'cover',
													}}
												/>
											</td>
											<td>{item?.description}</td>
											<td>
												<span
													onClick={() =>
														navigate('/edit/category', { state: item })
													}
													style={{ margin: 10, cursor: 'pointer' }}>
													EDIT
												</span>
												<span
													onClick={() => deleteCategory(item._id, index)}
													style={{ margin: 10, cursor: 'pointer' }}>
													{deletLoadingIndex === index
														? 'Loading..'
														: 'DELETE'}
												</span>
											</td>
										</tr>
									);
								})}
							</tbody>
						</table>
						<div
							style={{
								display: 'flex',
								justifyContent: 'center',
								alignItems: 'center',
							}}>
							{hasMore && (
								<button
									style={{
										border: 'none',
										padding: '10px',
										borderRadius: '10px',
									}}
									onClick={onLoadMore}>
									Load More...
								</button>
							)}
						</div>
					</CardBody>
				</Card>
			</PageWrapper>
		</>
	);
};

export default AllCategory;
